module.exports = "/_next/static/images/img_list-1-c71472f8927308b200ffe0aabfe7a664.png";